import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserModel } from "../../entities/user.model";
import { ResourceModel } from "../../entities/resource.model";
import { LoginResponseModel } from "../../entities/loginresponse.model";
import { InfoPlantUserModel } from "../../entities/infoplantuser.model";

@Injectable()
export abstract class UserRepositoryInterface {

    public abstract login(email: string, password: string): Observable<LoginResponseModel>;

    public abstract getLoggedUser(): Observable<UserModel>;

    public abstract getInfoPlantUser(email: string, password: string): Observable<InfoPlantUserModel>;

    public abstract getProfile(id: number): Observable<UserModel>;

    public abstract getResources(): Observable<ResourceModel[]>;

    public abstract createUser(email: string);

    public abstract changePassword(oldPassword: string, newPassword: string, userId: string);
}
